import createDependableResource from 'utils/zustand/createDependableResource'
import { ethers } from 'ethers'
import { getAccount, onAccountInitOrChange } from 'state/web3/account'
import { simpleRpcProvider } from 'utils/providers'
import { FetchStatus } from 'state/tokens/types'

export const useCroBalanceResource = createDependableResource<ethers.BigNumber>({
  initValue: ethers.BigNumber.from(0),
  getValue: async () => {
    const account = getAccount()
    if (!account) {
      return ethers.BigNumber.from(0)
    }
    return simpleRpcProvider.getBalance(account)
  },
  onInit: ({ resetValue, refresh, getIsStarted }) => {
    onAccountInitOrChange(() => {
      if (!getIsStarted()) return
      resetValue()
      refresh()
    })
  },
  dbgName: 'CroBalance',
})

export const useGetCroBalance = () => {
  const { value: balance, loaded, error, refresh } = useCroBalanceResource()
  return {
    balance,
    fetchStatus: error ? FetchStatus.FAILED : loaded ? FetchStatus.SUCCESS : FetchStatus.NOT_FETCHED,
    refresh,
  }
}
